module.exports = __webpack_public_path__ + "img/icon-arrow-readmore-down-blue.cd6d3cf0.svg";